<template>
    <section class="dispatchOrder-table" v-loading="loading">
        <div class="dispatch-table-header">
            <el-button
                type="text"
                class="dispatch-refresh"
                icon="el-icon-refresh"
                @click="refresh"
            >
                刷新
            </el-button>
        </div>
        <table-box
            ref="tablePage"
            :columns="config.table.columns"
            :height="config.table.height"
            :selection="config.selection"
            :rows="tableData"
            :actions="config.table.action"
            @action-click="actionClick"
        >
        </table-box>
        <!-- <m-page
            :current-page="currentPage"
            :pageData="config.page"
            :total="pageTotal"
            @on-page-change="pageChange"
            @on-size-change="sizeChange"
            class="page-container"
        ></m-page> -->
    </section>
</template>
<script>
// import mPage from '@/components/otpPanel/mPage';
import { formatTotalDataList } from './util';
import tableBox from '@/components/lots/tableBox/Index.vue';
import { queryStationArriveDetailByParam, updateStationArrivedForPC } from '../../../../../api/transferSystem';

export default {
    name: 'dispatchLookOverTable',
    components: { tableBox },
    props: {
        config: Object,
        activeName: {
            type: String,
            default () {
                return '';
            }
        },
        rowData: {
            type: Object,
            default () {
                return {};
            }
        },
        dictData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            loading: false,
            selected: [], // 选中数据
            tableData: [], // 列表数据
            page: {
                pageSize: 10,
                pageNo: 1
            },
            pageTotal: 0,
            currentPage: 1,
            func: queryStationArriveDetailByParam
        };
    },
    methods: {
        /**
             * @description 操作列事件处理
             * @event {事件类型} shipTo 运抵确认
             * @row   {Object} 行数据
            */
        actionClick (event, row, rIndex) {
            if (event === 'shipTo') {
                this.updatehandlearrivedcust(row.stationCode);
            }
        },
        // 页数改变
        sizeChange (data) {
            this.page.pageSize = data;
            this.getList();
        },
        // 切分页
        pageChange (data) {
            this.page.pageNo = data;
            this.getList();
        },
        /**
             * @getList 使用发车单号查询列表明细
             * @param {Object} searchParams 查询条件
             */
        async getList () {
            this.loading = true;
            const { taskNo, dispatchNo, customerOrderNo } = this.rowData;
            const param = { taskNo, dispatchNo, customerOrderNo };
            await this.func(param)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.tableData = formatTotalDataList(res.data || [], this.dictData);
                        // this.pageTotal = res.data.totalCount;
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        // 参数为空处理
        getSearchData (data) {
            const _searchData = {
                ...this.page,
                ...data,
                pageNo: 1
            };
            for (const key in _searchData) {
                if (_searchData[key] === '') delete _searchData[key];
            }
            return _searchData;
        },
        // 刷新
        refresh () {
            this.getList();
        },
        // 运抵确认
        updatehandlearrivedcust (stationCodeData) {
            this.loading = true;
            const param = {
                stationCode: stationCodeData,
                dispatchNo: this.rowData.dispatchNo,
                customerOrderNo: this.rowData.customerOrderNo
            };
            updateStationArrivedForPC(param)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('操作成功');
                        this.getList();
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    },
    watch: {
        // 监听tab变化
        activeName: {
            handler (val) {
                if (val === 'siteDetails') {
                    this.func = queryStationArriveDetailByParam;
                }
                this.getList();
            },
            immediate: true // 立即执行
        }
    }

};
</script>

<style  lang="less" scoped>
.dispatchOrder-table {
    .mPane3-back-up .el-table {
        min-height: inherit;
    }

    .dispatch-table-header {
        text-align: right;
    }
}
.dispatchOrder-table .model-table-search {
    display: none;
}
</style>
